import styled from 'styled-components';
import HasChildrenIcon from 'gatsby-theme-pdv/src/layouts/nav/nav-item/has-children-icon';

export default styled(HasChildrenIcon)`
  width: .6rem;
`;
